import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { StatusChip } from "@sinch/components/StatusChip/StatusChip";
import { CompanyStatusEnum } from "@sinch/core/entities/serverEnums";

/**
 * Active / inactive indicator for a company, the React counterpart of the legacy
 * `CompanyHelper::status()` badge.
 */
export const CompanyStatusChip: FC<{ status: CompanyStatusEnum | `${CompanyStatusEnum}` }> = ({ status }) => {
  const { t } = useTranslation();
  const isActive = status === CompanyStatusEnum.Active;

  return (
    <StatusChip
      label={isActive ? t("CompanyHeader.statusActive") : t("CompanyHeader.statusInactive")}
      size="tiny"
      sx={(theme) => ({
        backgroundColor: isActive ? theme.palette.success.main : theme.palette.error.main,
        color: theme.palette.common.white,
        lineHeight: "1rem",
      })}
    />
  );
};
